export const BOT_DATA = 'BOT_DATA';
export const BOT_ERROR = 'BOT_ERROR';
export const BOT_LOADING = 'BOT_LOADING';
export const BOT_DETAIL_SHOW = 'BOT_DETAIL_SHOW';
export const BOT_DETAIL_HIDE = 'BOT_DETAIL_HIDE';

export const BOT_LOG_TOGGLE_VIEWER = 'BOT_LOG_TOGGLE_VIEWER';
export const BOT_LOG_CONTENT_ERROR = 'BOT_LOG_CONTENT_ERROR';
export const BOT_LOG_LOADING = 'BOT_LOG_LOADING';
export const BOT_LOG_CONTENT = 'BOT_LOG_CONTENT';